export enum TableColumnType {
  Boolean,
  Currency,
  Custom,
  Date,
  DateTime,
  Number,
  Ordinal,
  Select,
  Text,
}
